import { render, staticRenderFns } from "./ModImageMap.vue?vue&type=template&id=40c833bd"
import script from "./ModImageMap.vue?vue&type=script&lang=js"
export * from "./ModImageMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports